module.exports = require("redux");


//////////////////
// WEBPACK FOOTER
// external "redux"
// module id = 530
// module chunks = 0